import React from 'react';
import { TextFieldProps } from 'mui-rff';
import { onlyNCharacters, onlyNumbers } from 'utils/formatters';

import Input from '../Input';

const only13Characters = onlyNCharacters(13);

type Props = {
  optional?: boolean;
};

const AccountInput = ({ fieldProps, optional, ...props }: TextFieldProps & Props) => (
  <Input
    optional={optional}
    fieldProps={{
      format: (value: string) => only13Characters(onlyNumbers(value)),
      parse: (value: string) => only13Characters(onlyNumbers(value)),
      ...fieldProps,
    }}
    {...props}
  />
);

export default AccountInput;
